const Hero = ({ image, alt }) => {
    return (
        <div id="hero" className="pt-3 pb-14 w-full flex justify-center align-middle bg-stone-800">
            <img src={image} alt={alt} className="w-full h-full object-cover" />
        </div>
    )
};

export default Hero;